import { useUiStore } from '@/stores/uiStore';
import { cn } from '@/lib/cn';
import { X } from 'lucide-react';

export function ToastViewport() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-80 flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            'animate-toast-in pointer-events-auto flex items-start gap-2 rounded-lg border px-3.5 py-2.5 shadow-lg',
            t.variant === 'error' && 'border-red-200 bg-red-50 text-red-900 dark:border-red-900/60 dark:bg-red-950/80 dark:text-red-100',
            t.variant === 'success' && 'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-900/60 dark:bg-emerald-950/80 dark:text-emerald-100',
            (!t.variant || t.variant === 'info') && 'border-slate-200 bg-white text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100',
          )}
        >
          <div className="flex-1">
            {t.title ? <p className="text-sm font-semibold">{t.title}</p> : null}
            <p className="text-sm">{t.message}</p>
          </div>
          <button
            type="button"
            aria-label="dismiss"
            className="rounded p-1 hover:bg-black/5 dark:hover:bg-white/10"
            onClick={() => dismiss(t.id)}
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      ))}
    </div>
  );
}
